import { type MultiSelectOption, type StringSelectOption } from "@tellescope/ui";
import { type TicketStatusFilter, type TicketTagsBehavior } from "./ticketFilters";
import { i18n } from "@tellescope/i18n";

export const COMPLETED_STAGE = "Completed";

export const NOT_STARTED_STAGE = "Not Started";

export const getStageOptions: () => MultiSelectOption<string>[] = () => [
  { value: NOT_STARTED_STAGE, label: i18n.t("Not Started", { ns: "tickets" }) },
  { value: "In Progress", label: i18n.t("In Progress", { ns: "tickets" }) },
  { value: "Blocked", label: i18n.t("Blocked", { ns: "tickets" }) },
  { value: "Archived", label: i18n.t("Archived", { ns: "tickets" }) },
  { value: COMPLETED_STAGE, label: i18n.t("Completed", { ns: "tickets" }) },
];

export const getStatusOptions: () => StringSelectOption<TicketStatusFilter>[] = () => [
  { value: "all", label: i18n.t("All", { ns: "tickets" }) },
  { value: "open", label: i18n.t("Open", { ns: "tickets" }) },
  { value: "closed", label: i18n.t("Closed", { ns: "tickets" }) },
];

export const getTagsBehaviorOptions: () => StringSelectOption<TicketTagsBehavior>[] = () => [
  { value: "match_any", label: i18n.t("Match Any", { ns: "tickets" }) },
  { value: "match_all", label: i18n.t("Match All", { ns: "tickets" }) },
  { value: "match_none", label: i18n.t("Match None", { ns: "tickets" }) },
];
